import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Landing
    title: "Diagnostic Dermo-Cosmétique",
    subtitle: "Analysez votre peau et découvrez votre routine idéale.",
    startDiagnosis: "Commencer le diagnostic",
    
    // Auth
    login: "Connexion",
    register: "Inscription",
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    forgotPassword: "Mot de passe oublié?",
    noAccount: "Pas encore de compte?",
    hasAccount: "Déjà un compte?",
    signUp: "S'inscrire",
    signIn: "Se connecter",
    
    // Analysis
    skinAnalysis: "Analyse de peau",
    chooseMethod: "Choisissez votre méthode",
    questionnaire: "Questionnaire",
    questionnaireDesc: "Répondez à quelques questions sur votre peau",
    cameraScan: "Scan caméra",
    cameraScanDesc: "Analysez votre peau avec l'IA",
    
    // Questionnaire
    skinType: "Quel est votre type de peau?",
    dry: "Sèche",
    oily: "Grasse",
    combination: "Mixte",
    normal: "Normale",
    hasAcne: "Avez-vous de l'acné?",
    hasDarkSpots: "Avez-vous des taches sombres ou de la pigmentation?",
    isSensitive: "Votre peau est-elle sensible?",
    ageGroup: "Groupe d'âge",
    yes: "Oui",
    no: "Non",
    next: "Suivant",
    previous: "Précédent",
    analyze: "Analyser",
    
    // Camera
    takePhoto: "Prendre une photo",
    retake: "Reprendre",
    analyzing: "Analyse en cours...",
    positionFace: "Positionnez votre visage dans le cercle",
    goodLighting: "Assurez-vous d'avoir une bonne luminosité",
    
    // Results
    yourResults: "Vos résultats",
    skinScore: "Score de peau",
    skinTypeResult: "Type de peau",
    mainConcern: "Préoccupation principale",
    morningRoutine: "Routine du matin",
    eveningRoutine: "Routine du soir",
    activeIngredients: "Ingrédients actifs recommandés",
    viewProducts: "Voir les produits",
    saveDiagnosis: "Sauvegarder",
    
    // Concerns
    acne: "Acné",
    dark_spots: "Taches sombres",
    wrinkles: "Rides",
    dehydration: "Déshydratation",
    sensitivity: "Sensibilité",
    none: "Aucune",
    
    // Products
    recommendedProducts: "Produits recommandés",
    category: "Catégorie",
    mainIngredient: "Ingrédient principal",
    allProducts: "Tous les produits",
    
    // Dashboard
    dashboard: "Tableau de bord",
    myDiagnoses: "Mes diagnostics",
    skinEvolution: "Évolution de ma peau",
    skincareTips: "Conseils skincare",
    newDiagnosis: "Nouveau diagnostic",
    noDiagnoses: "Aucun diagnostic sauvegardé",
    startFirst: "Commencez votre premier diagnostic",
    
    // Admin
    admin: "Administration",
    addProduct: "Ajouter un produit",
    importExcel: "Importer Excel",
    productName: "Nom du produit",
    description: "Description",
    targetConcerns: "Préoccupations ciblées",
    imageUrl: "URL de l'image",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    
    // Navigation
    home: "Accueil",
    scan: "Scanner",
    results: "Résultats",
    profile: "Profil",
    products: "Produits",
    logout: "Déconnexion",
    
    // General
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    back: "Retour",
    
    // Tips categories
    protection: "Protection",
    routine: "Routine",
    lifestyle: "Style de vie",
  },
  en: {
    // Landing
    title: "Dermo-Cosmetic Diagnostic",
    subtitle: "Analyze your skin and discover your ideal routine.",
    startDiagnosis: "Start diagnosis",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Full name",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signUp: "Sign up",
    signIn: "Sign in",
    
    // Analysis
    skinAnalysis: "Skin Analysis",
    chooseMethod: "Choose your method",
    questionnaire: "Questionnaire",
    questionnaireDesc: "Answer a few questions about your skin",
    cameraScan: "Camera Scan",
    cameraScanDesc: "Analyze your skin with AI",
    
    // Questionnaire
    skinType: "What is your skin type?",
    dry: "Dry",
    oily: "Oily",
    combination: "Combination",
    normal: "Normal",
    hasAcne: "Do you have acne?",
    hasDarkSpots: "Do you have dark spots or pigmentation?",
    isSensitive: "Is your skin sensitive?",
    ageGroup: "Age group",
    yes: "Yes",
    no: "No",
    next: "Next",
    previous: "Previous",
    analyze: "Analyze",
    
    // Camera
    takePhoto: "Take photo",
    retake: "Retake",
    analyzing: "Analyzing...",
    positionFace: "Position your face in the circle",
    goodLighting: "Make sure you have good lighting",
    
    // Results
    yourResults: "Your Results",
    skinScore: "Skin Score",
    skinTypeResult: "Skin Type",
    mainConcern: "Main Concern",
    morningRoutine: "Morning Routine",
    eveningRoutine: "Evening Routine",
    activeIngredients: "Recommended Active Ingredients",
    viewProducts: "View Products",
    saveDiagnosis: "Save",
    
    // Concerns
    acne: "Acne",
    dark_spots: "Dark spots",
    wrinkles: "Wrinkles",
    dehydration: "Dehydration",
    sensitivity: "Sensitivity",
    none: "None",
    
    // Products
    recommendedProducts: "Recommended Products",
    category: "Category",
    mainIngredient: "Main Ingredient",
    allProducts: "All Products",
    
    // Dashboard
    dashboard: "Dashboard",
    myDiagnoses: "My Diagnoses",
    skinEvolution: "Skin Evolution",
    skincareTips: "Skincare Tips",
    newDiagnosis: "New Diagnosis",
    noDiagnoses: "No saved diagnoses",
    startFirst: "Start your first diagnosis",
    
    // Admin
    admin: "Admin",
    addProduct: "Add Product",
    importExcel: "Import Excel",
    productName: "Product name",
    description: "Description",
    targetConcerns: "Target concerns",
    imageUrl: "Image URL",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    
    // Navigation
    home: "Home",
    scan: "Scan",
    results: "Results",
    profile: "Profile",
    products: "Products",
    logout: "Logout",
    
    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    
    // Tips categories
    protection: "Protection",
    routine: "Routine",
    lifestyle: "Lifestyle",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('dermascan_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('dermascan_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export default LanguageContext;
